export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6866.9d5c98f0.jpg";